import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=a5b4f3e4&scoped=true&"
import script from "./passwordForm.vue?vue&type=script&lang=js&"
export * from "./passwordForm.vue?vue&type=script&lang=js&"
import style0 from "./passwordForm.vue?vue&type=style&index=0&id=a5b4f3e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b4f3e4",
  null
  
)

export default component.exports